var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMrMauritania(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#CD2A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 6.75H0V38.25H60V6.75Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 14.4937C15.9375 18.2233 17.4191 21.8001 20.0563 24.4373C22.6935 27.0746 26.2704 28.5562 30 28.5562C33.7296 28.5562 37.3065 27.0746 39.9437 24.4373C42.5809 21.8001 44.0625 18.2233 44.0625 14.4937C44.375 15.6936 44.5325 16.9287 44.5312 18.1687C44.5312 22.0226 43.0003 25.7187 40.2751 28.4438C37.55 31.1689 33.8539 32.6999 30 32.6999C26.1461 32.6999 22.45 31.1689 19.7248 28.4438C16.9997 25.7187 15.4687 22.0226 15.4687 18.1687C15.4669 16.9286 15.6245 15.6935 15.9375 14.4937Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 8.79395L31.2656 12.6846H35.3438L32.0344 15.0846L33.3 18.9658L29.9906 16.5658L26.6813 18.9658L27.9469 15.0846L24.6375 12.6846H28.725L30 8.79395Z",
    fill: "#FFC400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrMauritania);
export default __webpack_public_path__ + "static/media/mr Mauritania.03ec6a513706f1ae3546fea108e48b2e.svg";
export { ForwardRef as ReactComponent };